/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import { createFragmentContainer, graphql } from 'react-relay';

import { Button } from './ui/button';
import { X } from 'lucide-react';

import Card from './Card';
import CreateInvitationMutation from '../mutations/CreateInvitationMutation';
import DeleteInvitationMutation from '../mutations/DeleteInvitationMutation';

class Invitations extends React.Component {
  constructor(props) {
    super(props);
    this.onRemove = this.onRemove.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.state = { foo: 'bar' };
  }

  onRemove(id) {
    return e => {
      return DeleteInvitationMutation.commit(id, this.props.channel.id);
    };
  }

  onCreate() {
    return CreateInvitationMutation.commit(this.props.channel.id, 'URL');
  }

  invitations() {
    return this.props.channel.invitations.edges.map(edge => {
      if (edge.node != null) {
        return (
          <div key={edge.node.id} className="flex flex-row items-center mb-2">
            <Button
              variant="ghost"
              size="icon"
              id={edge.node.id}
              onClick={this.onRemove(edge.node.id)}
            >
              <X className="h-4 w-4" />
            </Button>
            <div className="mr-2"> {edge.node.email} </div>
            <div className="break-all">
              <a href={edge.node.url} className="text-primary underline">
                {edge.node.url}
              </a>
            </div>
          </div>
        );
      }
      return null;
    });
  }

  render() {
    return (
      <Card className="bg-white p-0 px-4 pb-4 leading-relaxed min-h-[115px]">
        <div className="flex flex-row items-center mb-4">
          <h2 className="text-2xl font-semibold mb-4 flex-1">Invitations</h2>
          {this.props.relay.isLoading ? <div>Loading</div> : null}
          <Button onClick={this.onCreate}>Create</Button>
        </div>
        <p className="text-sm mb-4">
          Channels allow notifications to be sent to multiple users. To invite
          users to join a channel create and send them an invitation link.
        </p>
        {this.invitations()}
      </Card>
    );
  }
}

Invitations = createFragmentContainer(Invitations, {
  channel: graphql`
    fragment Invitations_channel on OwnedChannel {
      id
      invitations(first: 100) @connection(key: "Invitations_invitations") {
        edges {
          node {
            id
            kind
            email
            url
          }
        }
      }
    }
  `,
});

export default Invitations;
